module.exports = __webpack_public_path__ + "media/src/assets/images/lps-income_graph-5ea8f80e1925f0ccdca178d78a1519ae.png";